import { AdverticalService } from '../services/adverticalService/advertical.service';
import { UserService } from '../services/userService/user.service';

export function appInitializer(userService: UserService, adverticalService: AdverticalService) {
    return () => new Promise<void>(resolve => {
        let token = localStorage.getItem("appT");
        adverticalService.init().then(adsResp => {
            if (token) {
                userService.getUserInfo().then(resp => {
                    userService.getTerminalParams().then((configs:any) => {
                        userService.setServerConfigs(configs);
                        userService.checkStatus(resp);
                        resolve();
                    });
                })
            } else {
                userService.getToken().then(resp => {
                    userService.getUserInfo().then(resp => {
                        userService.getTerminalParams().then((configs:any) => {
                            userService.setServerConfigs(configs);
                            userService.checkStatus(resp);
                            resolve();
                        });
                    })
                });
            }
        });
    });
}